import React from "react";

import Grid from "@mui/material/Grid";
import VuiBox from "@/Components/VuiBox";
import VuiTypography from "@/Components/VuiTypography";
import VuiButton from "@/Components/VuiButton";

import { Furniture, ModelBrand } from "@/DatabaseControls/DataTypes";

import FurnitureImage from "./FurnitureImage";
import FurnitureInfo from "./FurnitureInfo";

import { useTranslation } from "react-i18next";

import _ from "lodash";

const FurnitureWindow = ({
  furnitureState,
  setFurnitureState,
  modelBrandList,
  onSave,
  onDelete,
}: {
  furnitureState: Furniture;
  setFurnitureState: (furniture: Furniture) => void;
  modelBrandList: ModelBrand[];
  onSave: () => void;
  onDelete: () => void;
}) => {
  const { t } = useTranslation();

  const isEdit = !!furnitureState.id;

  const handleSave = async () => {
    onSave();
  };

  const handleDelete = async (i) => {
    onDelete();
  };

  return (
    <>
      {furnitureState && (
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <VuiBox my={3}>
              <VuiBox mx={1} mt={1} mb={3}>
                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12} lg={6}>
                    <VuiTypography
                      variant="h4"
                      fontWeight="medium"
                      color="white"
                    >
                      {furnitureState?.Name || "New Furniture"}
                    </VuiTypography>
                    <VuiBox mt={1} mb={2}>
                      <VuiTypography variant="body2" color="text">
                        {t("common.pages.edit_description", {
                          title: _.toLower(
                            t("modules.furnitures.title_singular"),
                          ),
                        })}
                      </VuiTypography>
                    </VuiBox>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <VuiBox display="flex" justifyContent="flex-end" gap={1}>
                      {isEdit && (
                        <VuiButton
                          variant="contained"
                          color="error"
                          onClick={handleDelete}
                        >
                          {t("common.buttons.delete")}
                        </VuiButton>
                      )}

                      <VuiButton
                        variant="contained"
                        color="info"
                        onClick={handleSave}
                      >
                        {t("common.buttons.save")}
                      </VuiButton>
                    </VuiBox>
                  </Grid>
                </Grid>
              </VuiBox>
              <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={12}>
                  <FurnitureInfo
                    furniture={furnitureState}
                    setFurnitureState={setFurnitureState}
                    modelBrandList={modelBrandList}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FurnitureImage
                    furniture={furnitureState}
                    setFurnitureState={setFurnitureState}
                  />
                </Grid>
              </Grid>
            </VuiBox>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default FurnitureWindow;
